import { useChat } from "./chatKonteks";
import { IkonGelembung } from "./IkonChat";

/** PR chat pembeli: satu pintu tombol kontak pembeli. Chat aktif → tombol Chat (ikon chat, tanpa hijau WhatsApp). Mati → tautan WhatsApp persis seperti sekarang. */
export default function KontakWa({ href, konteks = null, tid, className, classChat, children, labelChat = "Chat", ariaLabel, ariaChat, ikon = true, ukuranIkon = 18, rel = "noreferrer", isiChat }) {
  const chat = useChat();
  if (chat.aktif) {
    return (
      <button type="button" className={classChat !== undefined ? classChat : className} data-testid={tid} data-kontak="chat" aria-label={ariaChat} onClick={() => chat.buka(konteks)}>
        {isiChat || <>{ikon && <IkonGelembung ukuran={ukuranIkon} />}{labelChat}</>}
      </button>
    );
  }
  if (!href) return null;
  return <a href={href} target="_blank" rel={rel} className={className} data-testid={tid} aria-label={ariaLabel}>{children}</a>;
}
